import { faAnglesUpDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment } from "react";

export const SpanIconAnglesAvatar = () => {
  return (
    <Fragment>
      <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
        <FontAwesomeIcon
          icon={faAnglesUpDown}
          className="h-4 w-4 text-gray-400"
        />
      </span>
    </Fragment>
  );
};
